// extracted by mini-css-extract-plugin
module.exports = {"type-icon":"styles_type-icon__1dIry"};